'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Sheet_module = require('../styles/Sheet.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Sheet Footer component.
 *
 * @component
 * @example
 * ```jsx
 * <Sheet.Footer>content</Sheet>
 * ```
 */
const Footer = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Sheet_module.default);
    return (React__namespace.createElement(Space.Space, { ref: ref, size: 12, justify: "stretch", className: cx(className, 'footer'), ...restProps }, children));
});
Footer.defaultProps = {};
Footer.displayName = 'Footer';

exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map
